import React from 'react'
import WebAddressSection from './web-address-section'

const EditWebAddressSection = ({ customSlug }) => (
  <WebAddressSection existingSlug={customSlug} isPublished />
)

export default EditWebAddressSection
